import zone from '../../../style/images/bg_pitch.png'
import field from '../../../style/images/bg_field.jpg'
import { getDecimalData } from '../../../Utils/utilFuncs'

let image = new Image();
image.src = zone;
export const zn_config = {
  plugins: [
    {
      id: "custom_canvas_background_image",
      beforeDraw: (chart) => {
        if (image.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          //var image_rwd_width = window.innerWidth * 0.32;
          //var image_rwd_height = window.innerWidth * 0.32;
          const x = left;
          const y = top;
          // console.log(image_rwd_height, image_rwd_width)
          ctx.drawImage(image, x, y, width, height);
        } else {
          image.onload = () => chart.draw();
        }
      }
    }
  ],
  options: {
    resposive: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        fullSize: false,
        boxWidth: 20,
        maxWidth: 20
      },
      datalabels: false,
      tooltip: {
        display: true,
        padding: 12,
        callbacks: {
          beforeBody: (context) => {
            let infos = []
            infos.push(`Game: ${context[0].raw.g}`)
            infos.push(`Inning: ${context[0].raw.inn}`)
            infos.push(`Count: ${context[0].raw.count}`)
            infos.push(`Pitcher: ${context[0].raw.p}`)
            infos.push(`Batter: ${context[0].raw.b}`)
            infos.push(`Velocity: ${context[0].raw.v}`)
            infos.push(`PitchType: ${context[0].raw.label}`)
            return infos
          },
          label: (context) => (`(${getDecimalData(context.raw.x, 1, 1, '-')}, ${getDecimalData(context.raw.y, 1, 1, '-')})`),
        },
      }
    },

    elements: {
      point: {
        pointRadius: 6,
        borderColor: 'rgb(0, 0, 0)'
      }
    },
    scales: {
      x: {
        min: -39.33333333,
        max: 39.33333333,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      },
      y: {
        min: -6,
        max: 67.6,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      }
    }
  }
};

let image2 = new Image();
image2.src = field;
export const hl_config = {
  plugins: [
    {
      id: "custom_canvas_background_image",
      beforeDraw: (chart) => {
        if (image2.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          //var image_rwd_width = window.innerWidth * 0.32;
          //var image_rwd_height = window.innerWidth * 0.32;
          const x = left;
          const y = top;
          // console.log(image_rwd_height, image_rwd_width)
          ctx.drawImage(image2, x, y, width, height);
        } else {
          image2.onload = () => chart.draw();
        }
      }
    }
  ],
  options: {
    resposive: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: false,
        position: "top",
        fullSize: false,
        boxWidth: 20,
        maxWidth: 20
      },
      datalabels: false,
      tooltip: {
        display: true,
        padding: 12,
        callbacks: {
          beforeBody: (context) => {
            let infos = []
            infos.push(`Game: ${context[0].raw.g}`)
            infos.push(`Inning: ${context[0].raw.inn}`)
            infos.push(`Count: ${context[0].raw.count}`)
            infos.push(`Pitcher: ${context[0].raw.p}`)
            infos.push(`Batter: ${context[0].raw.b}`)
            infos.push(`Result: ${context[0].raw.pr}`)
            return infos
          },
          label: (context) => (`(${getDecimalData(context.raw.x, 1, 1, '-')}, ${getDecimalData(context.raw.y, 1, 1, '-')})`),
        },
      }
    },

    elements: {
      point: {
        pointRadius: 4.5,
        borderWidth: 1.5,
        borderColor: 'rgb(0,0,0)'
      }
    },
    scales: {
      x: {
        min: -300,
        max: 300,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      },
      y: {
        min: -90.35,
        max: 509.65,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      }
    }
  }
};
